import React from "react";
import './lastName.css';

export default () => (
  <span className="user_last_name">
    Livshutz
  </span>
);


// WEBPACK FOOTER //
// ./src/components/userName/lastName/lastName.js